import gsap, { Power0, Power2, Power3 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

import _Sidemenu from '../_app/cuchillo/layout/Sidemenu';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { WaveSemiCircle } from '../components/WaveSemiCircle';
import ImagesCursor from '../components/ImagesCursor';
import ImagesCursorIndex, { ImageCursorIndex } from '../components/ImagesCursorIndex';
import { Basics, isMobile, isTouch } from '../_app/cuchillo/core/Basics';

export default class Sidemenu extends _Sidemenu {
  static _items = [];
  static _tick = 0;
  static links = [];
  static overlay;
  static wave;
  static wrapper;
  static bg;
  static closeBtn;
  static imagesCursor;
  static _calls = {
    mouseOver: (e) => this.changeIndex(e)
  }

  static init() {
    this.wave = new WaveSemiCircle(GetBy.class('__wave')[0]);
    this.closeBtn = GetBy.class('__close')[0];

    this.overlay = GetBy.class('__overlay')[0];
    gsap.set(this.overlay, { opacity: 0 });

    this.bg = GetBy.class('__bg')[0];
    gsap.set(this.bg, { x: '100%' });

    this.wrapper = GetBy.class('__wrapper')[0];
    gsap.set(this.wrapper, { x: '100%' });
    this.options.container = this.wrapper;

    this.links = GetBy.class('nav-item', this.container);
    gsap.set(this.links, { y: '100%' });
    for (let i = 0; i < this.links.length; i++) {
      const link = this.links[i];
      link.addEventListener(Basics.mouseOver, this._calls.mouseOver);
    }

    const items = Array.from(GetBy.class('__text', this.container));
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      this._items[i] = new SplitText(item, {
        type: 'chars',
        tag: 'span'
      }).chars;
    }

    if (!isMobile) {
      const visor = GetBy.class('__canvas', this.container)[0];
      this.imagesCursor = new ImagesCursorIndex(visor, this.container, ImageCursorIndex);
    }

    super.init();
  }

  static changeIndex(e) {
    this.imagesCursor.currentIndex = e.target.dataset.index;
  }

  static show__effect(__d = 0) {
    gsap.killTweensOf(this.links);
    gsap.killTweensOf(this.bg);
    gsap.killTweensOf(this.wrapper);
    gsap.killTweensOf(this.container);
    gsap.killTweensOf(this.overlay);

    gsap.set(this.container, { alpha: 0 });
    gsap.set(this.container, { alpha: 1, delay: __d });

    gsap.to(this.overlay, { opacity: .5, delay: __d, duration: .3 });

    let delay = __d;
    gsap.to([this.wrapper, this.bg], {
      x: '0',
      duration: 1,
      delay: __d,
      ease: Ease.EASE_CUCHILLO_OUT
    });
    this.wave.show(delay);

    delay = __d + .4;

    gsap.delayedCall(delay, () => {
      this.closeBtn.classList.add('animated');
      this.afterShow();
    })

    for (let i = 0; i < this.links.length; i++) {
      const link = this.links[i];
      gsap.to(link, { y: '0', duration: 1.2 + .1 * i, delay, ease: Ease.EASE_CUCHILLO_OUT });

      delay += .04;
    }
  }

  static hide__effect(__d = 0) {
    this.closeBtn.classList.remove('animated');

    gsap.killTweensOf(this.links);
    gsap.to(this.links, { y: '100%', duration: .4, delay: __d, ease: Ease.EASE_CUCHILLO_OUT });

    gsap.killTweensOf(this.bg);
    gsap.killTweensOf(this.wrapper);
    gsap.to([this.wrapper, this.bg], {
      x: '100%',
      duration: .6,
      delay: __d,
      ease: Ease.EASE_CUCHILLO_OUT
    });
    this.wave.hide(__d);

    gsap.killTweensOf(this.overlay);
    gsap.to(this.overlay, { opacity: 0, delay: __d, duration: .1 });

    gsap.killTweensOf(this.container);
    gsap.set(this.container, {
      alpha: 0,
      delay: __d + .6,
      onComplete: () => {
        this.afterHide();
      }
    });
  }

  static directHide() {
    super.directHide();
  }

  static show() {
    super.show();

    if (!isMobile) this.imagesCursor.show();
  }

  static afterShow() {
    super.afterShow();

    if (!isMobile) this.imagesCursor.center = false;
  }

  static beforeHide() {
    super.beforeHide();

    if (!isMobile) this.imagesCursor.center = true;
  }

  static hide() {
    super.hide();

    if (!isMobile) this.imagesCursor.hide();
  }

  static loop() {
    super.loop();

    this._tick++;
    this.wave.loop(this._tick);
    if (!isMobile) this.imagesCursor.loop();

  }

  static resize() {
    super.resize();

    this.wave.resize();
    if (!isMobile) this.imagesCursor.resize();
  }
}
